export default {
    routerName: '菜单管理',
    name: '菜单一览',
    menu: {
        frontEndName: '前端展示',
        backEndName: '后端管理',
        menuName: '菜单名',
        icon: '图标',
        url: 'URL',
        permit: '权限',
        sortOrder: '排序',
        type: '类型',
        catalog: '目录',
        typeMenu: '菜单',
        typeButton: '按钮',
        status: '状态',
        statusOpen: '启用',
        statusClose: '停用',
    },
    table: {
        id: 'ID',
        menuName: '菜单名',
        icon: '图标',
        url: 'URL',
        permit: '权限',
        sortOrder: '排序',
        type: '类型',
        status: '状态',
    },
    message: {
        delConfirmTitle: '删除警告',
        delIncludeSubNodeConfirm: '所有的子节点也消除吗？',
        delConfirm: '数据确定消除吗？',
    },
};
